import type { ReactElement } from 'react';

import { SecurityQuestionForm } from 'module/auth/security_question/components/SecurityQuestionForm';

import { useDeviceHandoffAccountFlow } from '../hooks/useDeviceHandoffAccountFlow';

export const SecurityQuestionRoute = (): ReactElement => (
    <SecurityQuestionForm {...useDeviceHandoffAccountFlow().securityQuestion} />
);
